import { apiUrlBillingAndInvoicing } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";

export const setBill = (payload) => ({
  type: at.SET_BILL,
  payload,
});

export const setInvoice = (payload) => ({
  type: at.SET_INVOICE,
  payload,
});

export const setInvoiceSettings = (payload) => ({
  type: at.SET_INVOICE_SETTINGS,
  payload,
});

export const setBillSettingList = (payload) => ({
  type: at.SET_BILL_SETTING_LIST,
  payload,
});

export const setBillSettingItem = (payload) => ({
  type: at.SET_BILL_SETTING_ITEM,
  payload,
});

export const setInvoiceRecipient = (payload) => ({
  type: at.SET_INVOICE_RECIPIENT,
  payload,
});

export const setInvoiceRecipientList = (payload) => ({
  type: at.SET_INVOICE_RECIPIENT_LIST,
  payload,
});

export const setInvoiceList = (payload) => ({
  type: at.SET_INVOICE_LIST,
  payload,
});

export const setBillList = (payload) => ({
  type: at.SET_BILL_LIST,
  payload,
});

export const setInvoiceSettingsList = (payload) => ({
  type: at.SET_INVOICE_SETTINGS_LIST,
  payload,
});

// export const getClosingCode =
//   (projectId, id, options = {}) =>
//   (_dispatch, _getState) => {
//     const url = `${apiUrlClosingCode.get.format(projectId)}${id}/`;
//     return Network.request(url, {
//       onSuccess: setClosingCode,
//       loading: true,
//       ...options,
//     });
//   };

// export const getClosingCodeList =
//   (projectId, params, options = {}) =>
//   (_dispatch, _getState) => {
//     return Network.request(apiUrlClosingCode.get.format(projectId), {
//       params,
//       loading: true,
//       ...options,
//     });
//   };

// export const createOrUpdateClosingCode = (projectId, data) => (_dispatch, _getState) => {
//   const url = data.id
//     ? apiUrlClosingCode.createOrUpdate.format(projectId, data.id)
//     : apiUrlClosingCode.get.format(projectId);
//   return Network.request(url, {
//     method: data.id ? "PATCH" : "POST",
//     data,
//     loading: true,
//     successMsg: true,
//   });
// };

// export const deleteClosingCode = (projectId, id) => (_dispatch, _getState) => {
//   const url = `${apiUrlClosingCode.get.format(projectId)}${id}`;
//   return Network.request(url, {
//     method: "DELETE",
//     loading: true,
//     successMsg: true,
//   });
// };

// export const setClosingCodeToSession = (projectId, sessionId, data) => (_dispatch, _getState) => {
//   const url = apiUrlClosingCode.setToSession.format(projectId, sessionId);
//   return Network.request(url, {
//     method: "POST",
//     data,
//     loading: true,
//     successMsg: true,
//   });
// };
export const getBill =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlBillingAndInvoicing.getBill.format(projectId)}${id}/`;
    return Network.request(url, {
      onSuccess: setBill,
      loading: true,
      ...options,
    });
  };

export const createOrUpdateBill = (projectId, data) => (_dispatch, _getState) => {
  const url = data.id
    ? `${apiUrlBillingAndInvoicing.getBill.format(projectId)}${data.id}/`
    : apiUrlBillingAndInvoicing.getBill.format(projectId);
  return Network.request(url, {
    method: data.id ? "PUT" : "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const deleteBill = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlBillingAndInvoicing.getBill.format(projectId)}${id}`;
  return Network.request(url, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const createInvoice = (projectId, data) => (_dispatch, _getState) => {
  const url = apiUrlBillingAndInvoicing.createInvoice.format(projectId);
  return Network.request(url, {
    method: "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const deleteInvoice = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlBillingAndInvoicing.deleteInvoice.format(projectId, id)}`;
  return Network.request(url, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const syncInvoice = (id) => (_dispatch, _getState) => {
  let url = apiUrlBillingAndInvoicing.syncInvoice;
  if (id) {
    url = `${url}${id}/`;
  }
  return Network.request(url, {
    method: "POST",
    loading: true,
    successMsg: true,
  });
};

export const getBillList =
  (projectId, options = {}) =>
  (_dispatch, _getState) => {
    const url = apiUrlBillingAndInvoicing.getBill.format(projectId);
    return Network.request(url, {
      onSuccess: (response) => _dispatch(setBillList(response?.results || [])),
      loading: true,
      ...options,
    });
  };

export const getInvoiceSettingsList =
  (projectId, options = {}) =>
  (_dispatch, _getState) => {
    const url = apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId);
    return Network.request(url, {
      onSuccess: (response) => _dispatch(setInvoiceSettingsList(response?.results || [])),
      loading: true,
      ...options,
    });
  };

export const getInvoiceSettings =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId)}${id}/`;
    return Network.request(url, {
      onSuccess: setInvoiceSettings,
      loading: true,
      ...options,
    });
  };

export const createOrUpdateInvoiceSettings = (projectId, data) => (_dispatch, _getState) => {
  const url = data.id
    ? apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId, data.id)
    : apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId);
  return Network.request(url, {
    method: data.id ? "PUT" : "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const deleteInvoiceSettings = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId)}${id}`;
  return Network.request(url, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const getBillSettingList =
  (projectId, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlBillingAndInvoicing.getBillingSettings.format(projectId)}/`;
    return Network.request(url, {
      onSuccess: (response) => setBillSettingList(response?.results || []),
      loading: true,
      ...options,
    });
  };

export const getBillSettingItem =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlBillingAndInvoicing.getBillingSettings.format(projectId)}${id}/`;
    return Network.request(url, {
      onSuccess: setBillSettingItem,
      loading: true,
      ...options,
    });
  };

export const createOrUpdateBillSettings = (projectId, data) => (_dispatch, _getState) => {
  const url = data.id
    ? `${apiUrlBillingAndInvoicing.getBillingSettings.format(projectId)}${data.id}/`
    : apiUrlBillingAndInvoicing.getBillingSettings.format(projectId);
  return Network.request(url, {
    method: data.id ? "PUT" : "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const deleteBillSettings = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlBillingAndInvoicing.getBillingSettings.format(projectId)}${id}`;
  return Network.request(url, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const getInvoiceRecipient =
  (projectId, id, options = {}) =>
  (_dispatch, _getState) => {
    const url = `${apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId)}${id}/`;
    return Network.request(url, {
      onSuccess: setInvoiceRecipient,
      loading: true,
      ...options,
    });
  };

export const getInvoiceRecipientList =
  (projectId, options = {}) =>
  (_dispatch, _getState) => {
    const url = apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId);
    return Network.request(url, {
      onSuccess: (response) => setInvoiceRecipientList(response?.results || []),
      loading: true,
      ...options,
    });
  };

export const createOrUpdateInvoiceRecipient = (projectId, data) => (_dispatch, _getState) => {
  const url = data.id
    ? `${apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId)}${data.id}/`
    : apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId);
  return Network.request(url, {
    method: data.id ? "PUT" : "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const deleteInvoiceRecipient = (projectId, id) => (_dispatch, _getState) => {
  const url = `${apiUrlBillingAndInvoicing.getInvoiceSettings.format(projectId)}${id}`;
  return Network.request(url, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};
